var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 8,
    viewBox: "0 0 28 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8536 4.35355C28.0488 4.15829 28.0488 3.84171 27.8536 3.64645L24.6716 0.464466C24.4763 0.269204 24.1597 0.269204 23.9645 0.464466C23.7692 0.659728 23.7692 0.976311 23.9645 1.17157L26.7929 4L23.9645 6.82843C23.7692 7.02369 23.7692 7.34027 23.9645 7.53553C24.1597 7.7308 24.4763 7.7308 24.6716 7.53553L27.8536 4.35355ZM0.5 4.5L27.5 4.5V3.5L0.5 3.5L0.5 4.5Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.29b6b3ed00bc415a5fcc33e78e48183f.svg";
export { ForwardRef as ReactComponent };